import Vue from 'vue'
import Router from 'vue-router'
import { lib } from '@comm/assets/js/lib'
import Home from '../views/home/Home.vue'
import Single from '../views/layout/Single.vue'
import Login from '@comm/views/Login4Workspace.vue'
import LoginNuaa from '@comm/views/Login4Workspace1.vue'
import Template from '@comm/views/Template.vue'
import fetch from '../../comm/api/fetch'
import store from '../store'



const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
}
Vue.use(Router)

const router = new Router({
  //mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: '首页'
      },
      children: [
        {
          path: '/',
          redirect: '/index'
        },
        {
          path: '/index',
          name: 'Index',
          component: resolve => require(['@/components/Index'], resolve),
          meta: {
            title: '首页'
          }
        },
        {
          path: '/form-submit',
          name: 'FormSubmit',
          component: resolve => require(['@/components/jobs/form-submit'], resolve),
          meta: {
            title: '表单提交'
          }
        }, {
          path: '/form-submit-gpu',
          name: 'FormSubmitGPU',
          component: resolve => require(['@/components/jobs/form-submit-gpu'], resolve),
          meta: {
            title: 'GPU表单提交'
          }
        },
        {
          path: '/vnc-submit',
          name: 'VncSubmit',
          component: resolve => require(['@/components/jobs/VncSubmit'], resolve),
          meta: {
            title: '图形化提交'
          }
        },
        {
          path: '/job-detail',
          name: 'JobDetail',
          component: resolve => require(['@/components/jobs/job-detail'], resolve),
          meta: {
            title: '作业详情'
          }
        },
        {
          path: '/windows-submit',
          name: 'WindowsSubmit',
          component: resolve => require(['@/components/jobs/windowsSubmit'], resolve),
          meta: {
            title: 'windows图形化提交'
          }
        },
        {
          path: '/windows-job-detail',
          name: 'WindowsJobDetail',
          component: resolve => require(['@/components/jobs/windows-job-detail'], resolve),
          meta: {
            title: 'windows作业详情'
          }
        },
        {
          path: '/jobTemplateDetail',
          name: 'JobTemplateDetail',
          component: resolve => require(['@/components/jobs/jobTemplateDetail'], resolve),
          meta: {
            title: '作业模板详情'
          }
        },
        {
          path: '/insideLetter',
          name: 'InsideLetter',
          component: resolve => require(['@/components/insideLetter'], resolve),
          meta: {
            title: '站内信'
          }
        },
        {
          path: '/insideLetter2',
          name: 'InsideLetter2',
          component: resolve => require(['@/components/insideLetter2'], resolve),
          meta: {
            title: '故障单'
          }
        },
        {
          path: '/me',
          name: 'Me',
          component: resolve => require(['@/components/me'], resolve),
          meta: {
            title: '个人中心'
          }
        },
        {
          path: '/changePassword',
          name: 'ChangePassword',
          component: resolve => require(['@/components/changePassword'], resolve),
          meta: {
            title: '修改密码'
          }
        }
      ]
    },
    {
      path: '/forget-password',
      name: 'ForgetPassword',
      component: resolve => require(['@/components/forget-password'], resolve),
      meta: {
        title: '找回密码'
      }
    },
    {
      path: '/bindWechat',
      name: 'BindWechat',
      component: resolve => require(['@/components/bindWechat'], resolve),
      meta: {
        title: '绑定微信'
      }
    },
    {
      path: '/callbackClose',
      name: 'CallbackClose',
      component: resolve => require(['@/components/callbackClose'], resolve),
      meta: {
        title: '回调关闭页面'
      }
    },
    {
      path: '/nuaa-register',
      name: 'nuaa-register',
      component: resolve => require(['@/components/nuaa/nuaa-register'], resolve),
      meta: {
        title: '南航注册页面'
      }
    },
    {
      path: '/nuaa-register-direct',
      name: 'nuaa-register-direct',
      component: resolve => require(['@/components/nuaa/nuaa-register-direct'], resolve),
      meta: {
        title: '南航注册成功页面'
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: '登录'
      }
    },
    {
      path: '/loginNuaa',
      name: 'LoginNuaa',
      component: LoginNuaa,
      meta: {
        title: '南航登录'
      }
    },
    {
      path: '/template',
      name: 'Template',
      component: Template,
      meta: {
        title: '模板'
      }
    },
    {
      path: '/single',
      name: 'Single',
      component: Single,
      meta: {
        title: ''
      },
      children: [
        {
          path: '/single',
          redirect: '/singleTerminal'
        },
        {
          path: '/singleTerminal',
          name: 'SingleTerminal',
          component: resolve => require(['@project2/components/web-terminal/terminal'], resolve),
          meta: {
            title: '控制台'
          }
        }]
    }
  ]
})

const whiteList = ['/403', '/login', '/template', '/forget-password', '/bindWechat', '/callbackClose', '/loginNuaa', '/nuaa-register', '/nuaa-register-direct'] // 设置白名单，避免死循环
let token = lib.cookie.get('Hpc-Platform-Token')
if (token && lib.sessionStorage.get("menus")) {
  let menus = JSON.parse(lib.sessionStorage.get("menus"))
  lib.generateRoutes(router, menus)
}
// 地址栏改变，比$route(to)先触发
router.beforeEach(async (to, from, next) => {
  if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
    next()
    return
  }
  let _token = lib.cookie.get('Hpc-Platform-Token')
  var url = window.location.href
  var ticket_url = url.split('#')[0]
  var ticket = ticket_url.split('ticket=')[1]
  if (_token) {
    next()
  } else { // 没有登录连接成功
    if (to.path.indexOf('/nuaa-register') < 0 && to.path.indexOf('/nuaa-register-direct') < 0 && ticket) { //此处判断来源 from
      fetch({ url: '/nuaa-integrate/api/cas/casLogin?ticket=' + ticket, method: 'get', encrypt: 'N' }).then((res) => {
        const code = res.code
        const data = res.data
        if (code === 'SUCCESS' && data && data.access_token) {
          lib.cookie.set('Hpc-Platform-Token', data.access_token)
          const current = this
          //拉取菜单列表
          fetch({ url: '/client/user/menus', method: 'get', encrypt: 'N' }).then((res) => {
            let menus = []
            menus.push({
              id: '-1',
              name: '首页',
              clientPath: '/index'
            })
            menus = menus.concat(res)
            store.commit('updateMenus', menus)
            let menusString = JSON.stringify(menus)
            lib.sessionStorage.set('menus', menusString)
            fetch({ url: '/client/user/summary-info', method: 'get', encrypt: 'N' }).then((res) => {
              //页面跳转
              let avatar = res.avatar
                ? res.avatar
                : 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png'
              store.commit('updateUser', {
                name: res.name,
                username: res.username,
                userProperty: res.userProperty,
                avatar: avatar,
                balance: res.balance
              })
              const clusters = res.clusters
              if (clusters) {
                store.commit('updateClusters', clusters)
                store.commit('updatecurrentCluster', {
                  clusterName: clusters[0].clusterName
                })
                lib.cookie.set('HEAD-CLUSTER-NAME', clusters[0].clusterName)
              }
              lib.sessionStorage.set('name', res.name)
              lib.sessionStorage.set('avatar', avatar)
              lib.sessionStorage.set('username', res.username)
              lib.sessionStorage.set('userProperty', res.userProperty)
              lib.sessionStorage.set('balance', res.balance)
              //南航2期
              //window.location.href = 'https://hpcpt2.nuaa.edu.cn/'
              //南航1期
              window.location.href = 'https://hpcpt.nuaa.edu.cn/'
            })
          })
        } else if (code === '1000') {
          //南航2期
          //window.location.href = 'https://hpcpt2.nuaa.edu.cn/#/nuaa-register?userGH=' + res.data
          //南航1期
          window.location.href = 'https://hpcpt.nuaa.edu.cn/#/nuaa-register?userGH=' + res.data
          // next('/nuaa-register?userGH=' + res.data)
        } else {
          next('/login')
        }
      })
    } else if (url.indexOf('/pass-user-direct') >= 0) {
      let getqyinfo = url.split('?')[1]
      let getqys = new URLSearchParams('?' + getqyinfo)
      let access_token = getqys.get('access_token')
      fetch({ url: '/api/paas-user/login?accessToken=' + access_token, method: 'post', encrypt: 'N' }).then((res) => {
        debugger
        if (res && res.access_token) {
          lib.cookie.set('Hpc-Platform-Token', data.access_token)
          const current = this
          //拉取菜单列表
          fetch({ url: '/client/user/menus', method: 'get', encrypt: 'N' }).then((res) => {
            let menus = []
            menus.push({
              id: '-1',
              name: '首页',
              clientPath: '/index'
            })
            menus = menus.concat(res)
            store.commit('updateMenus', menus)
            let menusString = JSON.stringify(menus)
            lib.sessionStorage.set('menus', menusString)
            fetch({ url: '/client/user/summary-info', method: 'get', encrypt: 'N' }).then((res) => {
              let avatar = res.avatar
                ? res.avatar
                : 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png'
              store.commit('updateUser', {
                name: res.name,
                username: res.username,
                userProperty: res.userProperty,
                avatar: avatar,
                balance: res.balance
              })
              const clusters = res.clusters
              if (clusters) {
                store.commit('updateClusters', clusters)
                store.commit('updatecurrentCluster', {
                  clusterName: clusters[0].clusterName
                })
                lib.cookie.set('HEAD-CLUSTER-NAME', clusters[0].clusterName)
              }
              lib.sessionStorage.set('name', res.name)
              lib.sessionStorage.set('avatar', avatar)
              lib.sessionStorage.set('username', res.username)
              lib.sessionStorage.set('userProperty', res.userProperty)
              lib.sessionStorage.set('balance', res.balance)
              next('/')
            })
          })
        } else {
          next('/login')
        }
      })
    }
    next('/login')
  }
})

export default router



// WEBPACK FOOTER //
// ./src/workspace/router/index.js